import { pb } from "./pocketbase";

export const bomService = {
  // Busca a receita (lista de insumos + quantidades) atrelada a um SKU (com fallback hierárquico para variações)
  async getRecipe(sku) {
    if (!sku) return [];
    
    const cleanSku = String(sku).trim().toUpperCase();

    // 1. Busca exata (Ex: ENG-ATL-24 se cadastrado diretamente)
    let recipe = await pb.collection("sku_bom").getFullList({
      filter: `sku="${cleanSku}"`,
      expand: "supply_id",
      sort: "-created"
    });

    if (recipe && recipe.length > 0) {
      return recipe;
    }

    // 2. Busca hierárquica (recorta hifens do fim para o início)
    // Ex: ENG-ATL-24 -> tenta "ENG-ATL" -> tenta "ENG"
    const parts = cleanSku.split("-");
    if (parts.length > 1) {
      for (let i = parts.length - 1; i >= 1; i--) {
        const potentialParentSku = parts.slice(0, i).join("-");
        console.log(`[BOM] Sem receita exata para ${cleanSku}. Tentando pai: ${potentialParentSku}`);
        
        recipe = await pb.collection("sku_bom").getFullList({
          filter: `sku="${potentialParentSku}"`,
          expand: "supply_id",
          sort: "-created"
        });

        if (recipe && recipe.length > 0) {
          console.log(`[BOM] Receita encontrada sob o SKU pai: ${potentialParentSku}`);
          return recipe;
        }
      }
    }

    return [];
  },

  // Adiciona um insumo à receita do SKU
  async addSupplyToRecipe(sku, supplyId, qtyPerUnit) {
    return await pb.collection("sku_bom").create({
      sku: sku.trim().toUpperCase(),
      supply_id: supplyId,
      quantity_per_unit: Number(qtyPerUnit)
    });
  },

  // Atualiza uma quantidade sem precisar deletar
  async updateSupplyInRecipe(id, qtyPerUnit) {
     return await pb.collection("sku_bom").update(id, {
        quantity_per_unit: Number(qtyPerUnit)
     });
  },

  // Remove um insumo da receita
  async removeSupplyFromRecipe(id) {
    return await pb.collection("sku_bom").delete(id);
  }
};
